var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ListFirestore',{attrs:{"item-name":"KaijuPayoutStateItem","get-collection":_vm.getKaijuPayouts,"order-list":_vm.orderList},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var state = ref.item;
return [_c('KaijuPayoutStateItem',{attrs:{"payout-state":state}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }